/** Priority 9 (20 Oct 2026): recorded interventions over the last 30 days and the units they relate to. */
export type OperationsMetrics={automatic:number;approval:number;professional_exception:number;manual?:number;human_seconds:number;units?:number;platform_events?:number};
/** People handled it: an approval, a professional exception or manual work. */
export function interventionsPer100Units(metrics:OperationsMetrics|undefined):number|null{
 if(!metrics?.units)return null;
 return Math.round((metrics.approval+metrics.professional_exception+(metrics.manual??0))*1000/metrics.units)/10;
}
